import '@mui/styles';
import { Theme } from '@mui/material';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './i18n';
import { RouterView } from 'components';
import { routes } from 'services/routes';
import accountRoutes from 'services/routes/account';
import libraryRoutes from 'services/routes/library';
import studioRoutes from 'services/routes/studio';
import distributionRoutes from 'services/routes/distribution';
import { analytics, analyticsListener } from 'services/analytics';
import { urlManager } from 'services/api/config';
import { cookieConsent } from 'services/iubenda';
import { AppErrorManager } from 'errorHelper';
import releasesRoutes from 'services/routes/releases';
import App from './App';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface DefaultTheme extends Theme {}
}

AppErrorManager.initialize();

// Runs Iubenda cookie consent
cookieConsent
  .onConsentGiven(() => {
    analytics.init();
    analyticsListener.analyticsInitialized = true;
  })
  .run();

const container = document.getElementById('root');

// @ts-ignore
const root = createRoot(container);

const router = createBrowserRouter(
  [
    {
      element: <App />,
      children: [
        ...accountRoutes,
        ...releasesRoutes,
        ...libraryRoutes,
        ...studioRoutes,
        ...distributionRoutes,
        { path: '*', element: <RouterView routes={routes} /> },
      ],
    },
  ],
  {
    basename: urlManager.homepage,
  }
);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
